import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const akf = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Flottenleasing Partnerwerkstätten in Ihrer Nähe",
      layout: {
        backText: "Zurück zu akf-mobility.de",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/akf",
      hint: {
        text: "Alle gezeigten Werkstätten sind offizielle akf-Mobility Service-Partner.",
      },
      profileHeader: {
        "checked-by": "geprüft durch akf-Mobility",
      },
    },
  },
};
